export const getFileCount = (state) =>
    state.file.files.maxCount;